/**
 * Available theme modes for the application
 */
export const ThemeModes = Object.freeze({
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
});

/**
 * Available colorblind modes persisted by vManage.
 */
export const ColorBlindModes = Object.freeze({
  OFF: "off",
  PROTANOPE: "protanope",
  DEUTERANOPE: "deuteranope",
  TRITANOPE: "tritanope",
});

export const COLOR_BLIND_MODE_VALUES = Object.freeze(
  Object.values(ColorBlindModes)
);

/**
 * localStorage key for persisting user theme preference
 */
export const THEME_STORAGE_KEY = "vanalytics.theme.mode";

/**
 * localStorage key set by vManage for colorblind mode preference.
 */
export const COLOR_BLIND_MODE_STORAGE_KEY = "vmanage.colorBlindMode";

/**
 * Body attribute used by vManage to expose the applied colorblind mode.
 */
export const COLOR_BLIND_MODE_ATTRIBUTE = "data-color-blind-mode";

/**
 * CSS class prefix used by vManage for colorblind mode filters.
 */
export const COLOR_BLIND_MODE_CLASS_PREFIX = "color-blind-mode-";

export const COLOR_BLIND_MODE_CLASS_BY_MODE = Object.freeze({
  [ColorBlindModes.PROTANOPE]:
    `${COLOR_BLIND_MODE_CLASS_PREFIX}${ColorBlindModes.PROTANOPE}`,
  [ColorBlindModes.DEUTERANOPE]:
    `${COLOR_BLIND_MODE_CLASS_PREFIX}${ColorBlindModes.DEUTERANOPE}`,
  [ColorBlindModes.TRITANOPE]:
    `${COLOR_BLIND_MODE_CLASS_PREFIX}${ColorBlindModes.TRITANOPE}`,
});

export const COLOR_BLIND_MODE_CLASSES = Object.freeze(
  Object.values(COLOR_BLIND_MODE_CLASS_BY_MODE)
);

/**
 * CSS class name applied to document elements when dark mode is active
 * Follows Harbor design system naming convention
 */
export const DARK_CLASS_NAME = "hbr-mode-dark";
